import { Signatory as SignatoryType } from "@/type/core/dashboard/dashboard.types";
import { Member } from "@/type/core/offices/offices.types";
import { PhoneHelper } from "@/utils/helpers/phone-helper";
import InfoModal from "@components/core/modals/InfoModal";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import Signatory from "@views/core/extranet/transactions/signature/Signatory";
import { ColumnsType } from "antd/lib/table/interface";
import i18n from "i18next";

export const columns = (
  isExpertComptable: boolean | undefined,
  isFromModel: boolean,
  experts: Member[],
  onDelete: (signatoryEmail: string) => void,
  activateSignLevel2: boolean = false,
  originEditor?: boolean,
): ColumnsType<SignatoryType> => [
  {
    key: "sort",
    width: 38,
    className: "text-center",
  },
  {
    dataIndex: "firstname",
  },
  {
    dataIndex: "lastname",
  },
  {
    dataIndex: "email",
  },
  {
    dataIndex: "phone",
    render: (phone: string) => {
      return phone ? (
        <div>{PhoneHelper.formatPhone(phone)}</div>
      ) : (
        <div>
          {isExpertComptable
            ? i18n.t("signature.roles.expert")
            : i18n.t("signature.roles.collaborator")}
        </div>
      );
    },
  },
  ...(!isFromModel
    ? ([
        {
          title: (
            <span className="d-block">
              {i18n.t("signature.signatories.withCertificate")}
              <InfoModal value="signatureLevel" info />
            </span>
          ),
          dataIndex: "key",
          className: "text-center",
          render: (_key: string, signatory: SignatoryType) => (
            <Signatory
              signatory={signatory}
              isModelSignatory={isFromModel}
              activateSignLevel2={activateSignLevel2}
              experts={experts}
              originEditor={originEditor}
            />
          ),
        },
      ] as ColumnsType<SignatoryType>)
    : []),
  {
    dataIndex: "key",
    width: 44,
    className: "text-center",
    render: (_, record) => {
      return (
        <DeleteIcon
          className="icon-30 cursor-pointer"
          onClick={(ev) => {
            ev.preventDefault();
            onDelete(record.email);
          }}
        />
      );
    },
  },
];
